import { Modal, ModalProps } from "@nestoca/ui";
import { useTranslation } from "react-i18next";

import { ApplicationSettingsModalBody } from "./application-settings-modal-body";
import styles from "./application-settings-modal.module.scss";

import type { SelectableApplication } from "../application-selector/types";

export type ApplicationSettingsModalProps = Pick<
  ModalProps,
  "visible" | "onClose"
> & {
  applicationId: number;
  applicantId: number;
  selectableApplications: SelectableApplication[];
};

export const ApplicationSettingsModal = ({
  visible,
  onClose,
  applicationId,
  applicantId,
  selectableApplications,
}: ApplicationSettingsModalProps) => {
  const { t } = useTranslation("common");

  return (
    <Modal
      visible={visible}
      onClose={onClose}
      closeOnOutsideClick
      className={styles["modal"]}
    >
      <Modal.Header
        closeButtonLabel={`${t("close")}`}
        className={styles["modal__header"]}
      />
      <Modal.Body>
        <ApplicationSettingsModalBody
          applicationId={applicationId}
          applicantId={applicantId}
          onClose={onClose}
          selectableApplications={selectableApplications}
        />
      </Modal.Body>
    </Modal>
  );
};
